"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var detect_browser_1 = require("detect-browser");
function usePwa() {
    var _this = this;
    var beforeinstallprompt = react_1.useRef();
    var _a = react_1.useState(false), appinstalled = _a[0], setAppinstalled = _a[1];
    var _b = react_1.useState(false), canInstallprompt = _b[0], setCanInstallprompt = _b[1];
    var _c = react_1.useState(false), enabledA2hs = _c[0], setEnabledA2hs = _c[1];
    var _d = react_1.useState(false), enabledPwa = _d[0], setEnabledPwa = _d[1];
    var _e = react_1.useState(false), isPwa = _e[0], setIsPwa = _e[1];
    var _f = react_1.useState(false), enabledUpdate = _f[0], setEnabledUpdate = _f[1];
    var _g = react_1.useState(), userChoice = _g[0], setUserChoice = _g[1];
    var showInstallPrompt = react_1.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var userChoice;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!beforeinstallprompt.current) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, beforeinstallprompt.current.prompt()];
                case 1:
                    _a.sent();
                    if (!beforeinstallprompt.current) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, beforeinstallprompt.current.userChoice];
                case 2:
                    userChoice = _a.sent();
                    setUserChoice(userChoice);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var unregister = react_1.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var registration, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!("serviceWorker" in window.navigator)) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, window.navigator.serviceWorker.getRegistration()];
                case 1:
                    registration = _a.sent();
                    if (!registration) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, registration.unregister()];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); }, []);
    var handleBeforeInstallPrompt = react_1.useCallback(function (event) {
        beforeinstallprompt.current = event;
        setCanInstallprompt(true);
    }, []);
    var handleAppinstalled = react_1.useCallback(function () {
        setAppinstalled(true);
    }, []);
    var _h = react_1.useState({
        appinstalled: false,
        beforeinstallprompt: false,
        enabledA2hs: false,
        enabledPwa: false,
        enabledUpdate: false,
        isPwa: false,
    }), completed = _h[0], setCompleted = _h[1];
    var isLoading = react_1.useMemo(function () { return !Object.values(completed).filter(function (value) { return value; }).length; }, [completed]);
    react_1.useEffect(function () {
        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        setCompleted(function (prevCompleted) { return (__assign(__assign({}, prevCompleted), { beforeinstallprompt: true })); });
        return function () {
            window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        };
    }, [handleBeforeInstallPrompt]);
    react_1.useEffect(function () {
        window.addEventListener("appinstalled", handleAppinstalled);
        setCompleted(function (prevCompleted) { return (__assign(__assign({}, prevCompleted), { appinstalled: true })); });
        return function () {
            window.removeEventListener("appinstalled", handleAppinstalled);
        };
    }, [handleAppinstalled]);
    react_1.useEffect(function () {
        setEnabledPwa("serviceWorker" in window.navigator &&
            "BeforeInstallPromptEvent" in window);
        setCompleted(function (prevCompleted) { return (__assign(__assign({}, prevCompleted), { enabledPwa: true })); });
    }, []);
    react_1.useEffect(function () {
        setIsPwa("standalone" in window.navigator ||
            window.matchMedia("(display-mode: standalone)").matches);
        setCompleted(function (prevCompleted) { return (__assign(__assign({}, prevCompleted), { isPwa: true })); });
    }, []);
    react_1.useEffect(function () {
        try {
            var browser = detect_browser_1.detect();
            if (!browser) {
                return;
            }
            var userAgent = window.navigator.userAgent.toLowerCase();
            var isIos = userAgent.indexOf("iphone") >= 0 ||
                userAgent.indexOf("ipad") >= 0 ||
                (userAgent.indexOf("macintosh") >= 0 && "ontouchend" in document);
            var name_1 = browser.name;
            setEnabledA2hs(isIos && name_1 === "ios");
        }
        finally {
            setCompleted(function (prevCompleted) { return (__assign(__assign({}, prevCompleted), { enabledA2hs: true })); });
        }
    }, []);
    react_1.useEffect(function () {
        var callback = function () { return __awaiter(_this, void 0, void 0, function () {
            var registration_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 2, 3]);
                        if (!("serviceWorker" in window.navigator)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, window.navigator.serviceWorker.getRegistration()];
                    case 1:
                        registration_1 = _a.sent();
                        if (!registration_1) {
                            return [2 /*return*/];
                        }
                        registration_1.onupdatefound = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, registration_1.update()];
                                    case 1:
                                        _a.sent();
                                        setEnabledUpdate(true);
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        return [3 /*break*/, 3];
                    case 2:
                        setCompleted(function (prevCompleted) { return (__assign(__assign({}, prevCompleted), { enabledUpdate: true })); });
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        callback();
    }, []);
    return {
        appinstalled: appinstalled,
        canInstallprompt: canInstallprompt,
        enabledA2hs: enabledA2hs,
        enabledUpdate: enabledUpdate,
        enabledPwa: enabledPwa,
        isLoading: isLoading,
        isPwa: isPwa,
        showInstallPrompt: showInstallPrompt,
        unregister: unregister,
        userChoice: userChoice,
    };
}
exports.default = usePwa;
//# sourceMappingURL=index.js.map